import { ButtonSpan } from "../../Button";
import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { saveData } from "../../../services/downloadFile";
import axios from "axios";
let CommercialDealInformation = ({ commercialDeal }) => {
  const token = useSelector(state => state.auth.token);
  if (!commercialDeal) {
    return <></>;
  }
  async function handleDownload(type, url, name) {
    try {
      const response = await axios.get(url, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      saveData(type, response.data, name);
    } catch (err) {
      alert("Sorry there was a problem fetching the file");
    }
  }

  return (
    <div className="p-3 bg-blue  bg-black text-white">
      <div className={""}>
        <span className="font-normal">Deal Applied:</span>
        <br />
        <span className="font-bold lg"> {commercialDeal.name}</span>
      </div>
      {/*<div className={"flex justify-between items-center py-1"}>*/}
      {/*  <span className="font-normal">From:</span><span className="font-bold text-xl">  {moment(commercialDeal.visible_from_date).format('DD/MM/YYYY')}</span>*/}
      {/*</div>*/}
      {/*<div className={"flex justify-between items-center py-1"}>*/}
      {/*  <span className="font-normal">To:</span><span className="font-bold text-xl">  {moment(commercialDeal.visible_to_date).format('DD/MM/YYYY')}</span>*/}
      {/*</div>*/}
    </div>
  );
};

export default CommercialDealInformation;
